import React, { Component } from 'react';
import $ from 'jquery';
import { I18n } from 'react-i18next';

export default class Section8 extends Component {
    constructor (props) {
        super(props);
        this.state = {
            home: 'home_57'
        }
    }

    componentDidMount () {
        $("#section8 .nav-tabs a").click(function() {
            $("#section8 .nav-tabs a").removeClass('active');
            $(this).addClass('active');

            $(".s8-bg .container div div").removeClass('active').removeClass('in');
            if (this.id === 'consnumer') {
                $(".s8-bg .container div #cs8t-consnumer").addClass('in').addClass('active');
            }
            if (this.id === 'issuert') {
                $(".s8-bg .container div #cs8t-issuert").addClass('in').addClass('active');
            }
            if (this.id === 'merchant') {
                $(".s8-bg .container div #cs8t-merchant").addClass('in').addClass('active');
            }
        });
    }


    render () {
        const language = localStorage.getItem('i18nextLng');
        return (
            <I18n>
                {
                    (t, { i18n }) => (
                        <div className="section" id="section8">
                            <div className="s8-bg">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 cs8-top nav nav-tabs">
                                            <a className={ 'btn cs8t-consnumer wow bounceInDown active' }
                                               id={'consnumer'}
                                               data-toggle="tab" href="#cs8t-consnumer">
                                                <span className="slant-left"/>
                                                <span className="cs8t-title">{t('home_57')}</span>
                                                <span className="slant-right"/>
                                            </a>

                                            <a className={ 'btn cs8t-issuert wow bounceInDown' }
                                               id={'issuert'}
                                               data-wow-delay="1s"
                                               href="#cs8t-issuert" data-toggle="tab">
                                                <span className="slant-left"/>
                                                <span className="cs8t-title">{t('home_58')}</span>
                                                <span className="slant-right"/>
                                            </a>
                                            <a className={ 'btn cs8t-merchant wow bounceInDown' }
                                               id={'merchant'}
                                               data-wow-delay="2s"
                                               data-toggle="tab" href="#cs8t-merchant">
                                                <span className="slant-left"/>
                                                <span className="cs8t-title">{t('home_59')}</span>
                                                <span className="slant-right"/>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="row tab-content">
                                        <div id="cs8t-consnumer" className="tab-pane fade in active">
                                            <div className="col-xs-12 col-sm-6 col-md-6 cs8-left wow animated slideInLeft">
                                                <img src="/images/s7_1.png" alt=""/>
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 cs8-right">
                                                <h2 className="wow fadeInRightBig">{t('home_51')}</h2>
                                                <p className="wow fadeInUp" data-wow-delay="1s">
                                                    <span>{t('home_52')}</span>
                                                    <span>{t('home_53')}</span>
                                                    <span>{t('home_54')}</span>
                                                </p>
                                                <p className="wow fadeInUp" data-wow-delay="1.5s">
                                                    <span>{t('home_55')}</span>
                                                    <span>{t('home_56')}</span>
                                                </p>
                                                <p className="text-center wow fadeInUp go-wrapper" data-wow-delay="1.7s">
                                                    <a className="btn btn-go" target="_blank" rel="noopener noreferrer" href="https://wallet.triamnetwork.com/">
                                                        {t('home_91')}
                                                    </a>
                                                </p>
                                            </div>
                                        </div>
                                        <div id="cs8t-issuert" className="tab-pane fade">
                                            <div className="col-xs-12 col-sm-6 col-md-6 cs8-right">
                                                <h2>{t('home_82')}</h2>
                                                <p>{t('home_83')}</p>
                                                <p>{t('home_84')}</p>
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 cs8-left">
                                                <img src={`/images/s8_${language === 'ja' ? 'ja' : language}.png`} className="animated slideInRight" alt=""/>
                                            </div>
                                        </div>
                                        <div id="cs8t-merchant" className="tab-pane fade">
                                            <div className="col-xs-12 col-sm-6 col-md-6 cs8-left animated slideInLeft ">
                                                <img src="/images/s8_3.png" alt=""/>
                                            </div>
                                            <div className="col-xs-12 col-sm-6 col-md-6 cs8-right">
                                                <h2>{t('home_88')}</h2>
                                                <p>{t('home_90')}</p>
                                                <p>{t('home_89')}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </I18n>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/section8.jsx